// fake init function
export const init = () => true
